import { gql } from "apollo-boost";

export const GET_ATTACHMENT = gql`
    query GetAttachment($id: ID!) {
        attachment(id: $id) {
            id
            name
            title
            extension
            display_url
        }
    }
`;
